import { render, staticRenderFns } from "./Retards.vue?vue&type=template&id=522092c6&"
import script from "./Retards.vue?vue&type=script&lang=js&"
export * from "./Retards.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports